export enum MessagePublisher {
  User = "User",
  AI = "AI"
}
